module.exports = __webpack_public_path__ + "static/media/sc8r_5.49e1ea75.gif";